import type { DbProtocolComposition } from './types';

// Runtime guard for admin-written documents read without a schema.
export const isDbProtocolComposition = (
  value: unknown
): value is DbProtocolComposition =>
  typeof value === 'object' &&
  value !== null &&
  typeof (value as { prescreener?: unknown }).prescreener === 'boolean' &&
  typeof (value as { icf?: unknown }).icf === 'boolean';
